import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import { Cast } from "@jdion/cast";
import { CastProvider } from "@jdion/cast-react";
import TvPlayer from "./tvplayer";
import Radio from "./radio";
import Login from "./login";
import Home from "./home";
import AuthProvider from "./context/AuthProvider";
import ProtectedRoute from "./protectedRoutes/ProtectedRoute";
import Page404 from "./404";
import Landing from "./landing";

/*window.addEventListener("contextmenu", (e) => e.preventDefault());

 window.addEventListener("keydown", (e) => {
  if (
    e.key === "F12" ||
    (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) ||
    (e.ctrlKey && e.key === "U") // Ctrl+U
  ) {
    e.preventDefault();
    alert("Acción no permitida");
  }
});
 */

const cast = new Cast();

const AppWrapper = () => {
  return (
    <CastProvider instance={cast}>
      <Router>
        <AuthProvider>
          <Routes>
            <Route element={<App />} path="/play" exact />
            <Route element={<TvPlayer />} path="/tvplayer" />
            <Route element={<Radio />} path="/radio" />
            <Route element={<Login />} path="/login" />
            <Route element={<Landing />} path="/" />
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Page404 />} />
          </Routes>
        </AuthProvider>
      </Router>
    </CastProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => console.log("Service Worker registrado:", reg))
      .catch((err) => console.error("Error registrando Service Worker:", err));
  });
}